import { render, staticRenderFns } from "./OurTruck.vue?vue&type=template&id=1a25feac&scoped=true&"
import script from "./OurTruck.vue?vue&type=script&lang=js&"
export * from "./OurTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25feac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/brianking/Sites/Vue/randy/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VContainer,VFlex,VIcon,VLayout})
